import React from 'react';
import PropTypes from 'prop-types';
import { TwitterShareButton } from 'react-share';
import SocialShareAtag from '../Shared/SocialShareAtag';
import Container from '../Shared/Container';
import ButtonContainer from '../Shared/ButtonContainer';
import Icon from '../Shared/Icon';
import IconText from '../Shared/IconText';

const TwitterSocialShareButton = (props) => (
  <Container>
    <TwitterShareButton url={props.url} title={props.title} style={{ outline: 'none' }}>
      <SocialShareAtag backgroundColor="#38A1F3">
        <ButtonContainer>
          <Icon>
            <svg
              viewBox="0 0 33 33"
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g>
                <path d="M 32,6.076c-1.177,0.522-2.443,0.875-3.771,1.034c 1.355-0.813, 2.396-2.099, 2.887-3.632 c-1.269,0.752-2.674,1.299-4.169,1.593c-1.198-1.276-2.904-2.073-4.792-2.073c-3.626,0-6.565,2.939-6.565,6.565 c0,0.515, 0.058,1.016, 0.17,1.496c-5.456-0.274-10.294-2.888-13.532-6.86c-0.565,0.97-0.889,2.097-0.889,3.301 c0,2.278, 1.159,4.287, 2.921,5.465c-1.076-0.034-2.088-0.329-2.974-0.821c-0.001,0.027-0.001,0.055-0.001,0.083 c0,3.181, 2.263,5.834, 5.266,6.438c-0.551,0.15-1.131,0.23-1.73,0.23c-0.423,0-0.834-0.041-1.235-0.118 c 0.836,2.608, 3.26,4.506, 6.133,4.559c-2.247,1.761-5.078,2.81-8.154,2.81c-0.53,0-1.052-0.031-1.566-0.092 c 2.905,1.863, 6.356,2.95, 10.064,2.95c 12.076,0, 18.679-10.004, 18.679-18.68c0-0.285-0.006-0.568-0.019-0.849 C 30.007,8.548, 31.12,7.392, 32,6.076z" />
              </g>
            </svg>
          </Icon>
          <IconText>Tweet</IconText>
        </ButtonContainer>
      </SocialShareAtag>
    </TwitterShareButton>
  </Container>
);

TwitterSocialShareButton.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
};

TwitterSocialShareButton.defaultProps = {
  title: '',
};

export default TwitterSocialShareButton;
